import { useState, type FormEvent } from 'react';
import { backend } from '../data';
import { BhStore } from '@bhorosha/data';
import type { Session } from '@bhorosha/data';
import { t, tErr } from '@bhorosha/i18n';
import { ErrorText, Field, Modal, Notice, PasswordInput } from '../ui/components';

export function AccountPanel({ session, onClose }: { session: Session; onClose: () => void }) {
  const [name, setName] = useState(session.displayName);
  const [pw, setPw] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function run(fn: () => Promise<void>, ok: string) {
    setBusy(true); setErr(''); setMsg('');
    try { await fn(); setMsg(ok); } catch (e) { setErr(tErr(e)); } finally { setBusy(false); }
  }
  const saveName = (e: FormEvent) => { e.preventDefault(); void run(() => backend.updateDisplayName(name.trim()), t('fam.saved')); };
  const savePw = (e: FormEvent) => {
    e.preventDefault();
    if (pw.length < 8) { setErr(t('auth.err.short')); return; }
    void run(async () => { await backend.updatePassword(pw); setPw(''); }, t('auth.passwordUpdated'));
  };

  return (
    <Modal title={t('acct.title')} onClose={onClose}>
      <p className="bh-muted bh-small">{t('acct.signedInAs', { email: session.email })}</p>
      <form className="bh-form" onSubmit={saveName}>
        <Field label={t('acct.name')}><input value={name} onChange={e => setName(e.target.value)} required /></Field>
        <button className="bh-btn bh-btn-ghost" disabled={busy}>{t('common.save')}</button>
      </form>
      <form className="bh-form" onSubmit={savePw}>
        <Field label={t('acct.changePassword')}>
          <PasswordInput value={pw} onChange={setPw} strength />
        </Field>
        <button className="bh-btn bh-btn-ghost" disabled={busy || !pw}>{t('acct.changePassword')}</button>
      </form>
      {msg && <Notice tone="ok">{msg}</Notice>}
      <ErrorText>{err}</ErrorText>
      <div className="bh-danger-zone">
        <h3 className="bh-h3">{t('acct.delete')}</h3>
        <p className="bh-small bh-muted">{t('acct.deleteHelp')}</p>
        <button className="bh-btn bh-btn-danger" disabled={busy} onClick={async () => {
          const typed = prompt(t('acct.deleteConfirm', { email: session.email }));
          if (typed === null || typed.trim().toLowerCase() !== session.email.toLowerCase()) return;
          setBusy(true); setErr('');
          try { await backend.deleteAccount(); BhStore.clearDeviceCache(localStorage); location.href = '/'; }
          catch (e) { setErr(tErr(e)); setBusy(false); }
        }}>{t('acct.delete')}</button>
      </div>
    </Modal>
  );
}
